<template>
    <div class="call-center" v-bind:class="ComputedClass">
        <div class="call-center__wrap">
            <div alt="Контакт-центр" class="call-center__image"></div>
            <div class="call-center__text-wrap">
                <h3 class="call-center__title" v-html="changeTitle"></h3>
                <!--                <a href="tel:+77273559696" class="call-center__link call-center__link&#45;&#45;phone">+7 (727) 355-96-96</a>-->
                <a href="mailto:help@microfin.kz" class="call-center__link">help@microfin.kz</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "callCenter",
    props: {
        type: {
            default: "flat"
        },
        color: {
            default: "white"
        }
    },
    computed: {
        changeTitle() {
            if (this.isCabinetType) {
                return "Необходима помощь?";
            } else {
                return "Есть вопросы?";
            }
        },
        isWhiteColor() {
            return this.color === "white";
        },
        isYellowColor() {
            return this.color === "yellow";
        },
        isFlatType() {
            return this.type === "flat";
        },
        isBlockType() {
            return this.type === "block";
        },
        isCabinetType() {
            return this.type === "cabinet";
        },
        ComputedClass: function() {
            return {
                "call-center--color-yellow": this.isYellowColor,
                "call-center--color-white": this.isWhiteColor,
                "call-center--type-block": this.isBlockType,
                "call-center--type-flat": this.isFlatType,
                "call-center--type-cabinet": this.isCabinetType
            };
        }
    }
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";
@import "~@/assets/scss/site/desktop/how-to-get/call-center";
@import "~@/assets/scss/site/mobile/how-to-get/call-center";
</style>